module.exports = __webpack_public_path__ + "img/img52.360017aa.jpg";